export const endpoint = `https://restcountries.eu/rest/v2/all`;
